import {Alerter} from '../helpers/alerter';

export const REPLACE_CART_TEXT = 'Als u op leegmaken klikt worden alle items uit uw winkelwagen verwijderd. ';
export const REPLACE_CART_TITLE = 'WEET U HET ZEKER ?';
export const REPLACE_CART_CANCEL = 'Annuleren';
export const REPLACE_CART_ACCEPT = 'Ja, leegmaken';

export const needsReplaceCartConfirmation = ({hasItems, hasQuotation}) =>
    Boolean(hasItems) && Boolean(hasQuotation);

export const confirmReplaceCartIfNeeded = ({hasItems, hasQuotation}) =>
    new Promise((resolve) => {
        if (!needsReplaceCartConfirmation({hasItems, hasQuotation})) {
            resolve({cleanCart: false, confirmed: true});
            return;
        }
        new Alerter({
            title: REPLACE_CART_TITLE,
            text: REPLACE_CART_TEXT,
            cancelText: REPLACE_CART_CANCEL,
            acceptText: REPLACE_CART_ACCEPT,
            onAccept: () => resolve({cleanCart: true, confirmed: true}),
            onCancel: () => resolve({cleanCart: false, confirmed: false}),
        });
    });

const QUOTATION_ORDER_TEXT = 'Bij het bestellen van een offerte mogen er geen andere artikelen in de winkelwagen zitten.. ';
const QUOTATION_ORDER_TITLE = 'Offerte bestellen ?';
const QUOTATION_ORDER_CANCEL = 'Annuleren';
const QUOTATION_ORDER_ACCEPT = 'Ja, bestellen';

export const confirmQuotationOrderIfNeeded = ({hasItems}) =>
    new Promise((resolve) => {
        if (!hasItems) {
            resolve({confirmed: true});
            return;
        }
        new Alerter({
            title: QUOTATION_ORDER_TITLE,
            text: QUOTATION_ORDER_TEXT,
            cancelText: QUOTATION_ORDER_CANCEL,
            acceptText: QUOTATION_ORDER_ACCEPT,
            onAccept: () => resolve({confirmed: true}),
            onCancel: () => resolve({confirmed: false}),
        });
    });

export default {
    confirmReplaceCartIfNeeded,
    confirmQuotationOrderIfNeeded,
};
